// Auto-generated index of all AI Prompt components

import AI_Prompt_Home from "./ai_prompt_components/AI_Prompt_Home.jsx";
import AI_Prompt_Intro from "./ai_prompt_components/AI_Prompt_Intro.jsx";
import AI_Text_to_Text from "./ai_prompt_components/AI_Text_to_Text.jsx";
import Bard from "./ai_prompt_components/Bard.jsx";
import ChatGPT_3_5 from "./ai_prompt_components/ChatGPT_3_5.jsx";
import ChatGPT_4 from "./ai_prompt_components/ChatGPT_4.jsx";
import Intro from "./ai_prompt_components/Intro.jsx";

const AllAiPromptComponents = {
  "<AI_Prompt_Home />": AI_Prompt_Home,
  "<AI_Prompt_Intro />": AI_Prompt_Intro,
  "<AI_Text_to_Text />": AI_Text_to_Text,
  "<Bard />": Bard,
  "<ChatGPT-3.5 />": ChatGPT_3_5,
  "<ChatGPT-4 />": ChatGPT_4,
  "<Intro />": Intro,
};

export default AllAiPromptComponents;
